"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneUtil = void 0;
var phone = require('phone');
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var PNF = require('google-libphonenumber').PhoneNumberFormat;
var PhoneUtil = /** @class */ (function () {
    function PhoneUtil() {
    }
    PhoneUtil.isValid = function (phoneNumber, country) {
        return PhoneUtil.isValidLib(phoneNumber, country);
    };
    PhoneUtil.asYouTypeFormatter = function (country) {
        var AsYouTypeFormatter = require('google-libphonenumber').AsYouTypeFormatter;
        return new AsYouTypeFormatter(country || 'JP');
    };
    PhoneUtil.isValidPhone = function (phoneNumber, country) {
        if (!phoneNumber)
            return false;
        var response = phone(phoneNumber, country || 'JP');
        if (Array.isArray(response) && response.length > 0) {
            return true;
        }
        return false;
    };
    PhoneUtil.isValidLib = function (phoneNumber, country) {
        if (!phoneNumber)
            return false;
        try {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.isValidNumberForRegion(number, country || 'JP');
        }
        catch (e) { }
        return false;
    };
    PhoneUtil.formatE164 = function (phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.E164);
        }
        return undefined;
    };
    PhoneUtil.formatNational = function (phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.NATIONAL);
        }
        return undefined;
    };
    PhoneUtil.formatInternational = function (phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.INTERNATIONAL);
        }
        return undefined;
    };
    PhoneUtil.formatRFC3966 = function (phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.RFC3966);
        }
        return undefined;
    };
    return PhoneUtil;
}());
exports.PhoneUtil = PhoneUtil;
//# sourceMappingURL=PhoneUtil.js.map